import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TermsService } from '../../components/terms/terms.service';
import { UtilitiesService } from '../shared/services/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class ConsentGuard implements CanActivate {
  constructor(
    private _termsService: TermsService,
    private _utilitiesService: UtilitiesService,
    private _route: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      this._utilitiesService.addMinorAction('CheckConsent');
      return new Promise((resolve, reject) => {
        this._termsService.hasValidConsent().subscribe(
          data => {
            this._utilitiesService.removeAction('CheckConsent');
            if (this._utilitiesService.getData(data)) {
              resolve(true);
            } else {
              this._route.navigate(['terms']);
              resolve(false);
            }
          },
          err => {
            this._utilitiesService.removeAction('CheckConsent');
            this._route.navigate(['terms']);
            resolve(false);
          }
        );
      });
  }
}
